import * as React from 'react';

import type { CashFlow } from '../../../output/models';

import { CashFlowRow } from './CashFlowRow';
import { TableHeader } from './TableHeader';

interface Props {
  cashFlows: CashFlow[];
  quarter?: number;
}

export const CashFlowTable: React.FC<Props> = ({ cashFlows, quarter }) => {
  return (
    <table className="row-striped w-full">
      <TableHeader />
      <tbody>
        {cashFlows
          .filter((cashFlow) => (quarter ? quarter === cashFlow.quarter : true))
          .map((cashFlow, index) => (
            <CashFlowRow
              cashFlow={cashFlow}
              showAccountingPeriod={quarter ? true : showAccountingPeriod(cashFlows, index)}
              key={index}
            />
          ))}
      </tbody>
    </table>
  );
};

const showAccountingPeriod = (cashFlows: CashFlow[], index: number): boolean => {
  if (index === 0) {
    return true;
  } else {
    const year = cashFlows[index].year;
    const month = cashFlows[index].month;
    const nextYear = cashFlows[index - 1].year;
    const nextMonth = cashFlows[index - 1].month;

    return year != nextYear || (year == nextYear && month != nextMonth);
  }
};
